module.exports = __webpack_public_path__ + "static/media/Pignite_gaussian2.951a4aa0.png";